import React from "react";
import RoutesComponent from "./Route";

function App() {
  return (
    <div className="App">
      <RoutesComponent />
    </div>
  );
}

export default App;
